module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAtCAMAAAB24NBkAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAADBQTFRFytfR1dbW2uvk8fLy0+fe7OzsydLO5fDp+vv78/j1zd/X1+nh4eHi0dHR3u7p////6N+hhAAAAO1JREFUeNps0dGWhSAIQNHEUsuL/v/fDkgi2PC4l+tgdvR+5xa7n6NDbQ3uXXOjgV3LyZw37cB67joS/jCpJM5NR6JCcfoLic9u3YB47lejs4jP9w4RMe1fR9v+SZBKwu0jlUSD7O8rCdp4W52JVq2+CfMYrJqg9r1UExRpZepKNPmeoSvxsqhJjJ8o6hL0UqKUSPWrLqFKiUM1T+UETK2qNqEFl1hqEpCK6ko8eKleMwHJaEF5Czgw3Kr8QnS4JsSwtnEiPQ8hYlzKiXeMckLGFjghc1ntU4vT3zzqNE50OvZdfdeIIfaP6vwJMAAH9DBZck0boQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/SP/assets/DE.png
// module id = xSfi
// module chunks = 1